function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { forwardRef } from 'react';
import styled from 'styled-components';
import { Box } from '@cbhq/cds-web/layout/Box';
import { palette } from '@cbhq/cds-web/tokens';
import { mediaQueries, breakpointKeys } from '../../breakpoints.js';
import { jsx } from 'react/jsx-runtime';
const pinStyles = {
  all: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  },
  top: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0
  },
  bottom: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0
  },
  left: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0
  },
  right: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO Fix this

const space = value => `calc(${value} * var(--spacing-1))`;
const color = value => typeof value === 'object' ? `rgba(var(--${value[0]}), ${value[1]})` : value in palette ? palette[value] : `rgb(var(--${value}))`;
const stylePropFunctions = {
  gridColumn: true,
  gridRow: true,
  gridAutoFlow: true,
  gridAutoColumns: true,
  gitAutoRows: true,
  gridTemplate: true,
  gridTemplateColumns: true,
  gridTemplateRows: true,
  gridTemplateAreas: true,
  gridArea: true,
  zIndex: true,
  position: true,
  top: true,
  right: true,
  bottom: true,
  left: true,
  display: true,
  overflow: true,
  overflowX: true,
  overflowY: true,
  width: true,
  height: true,
  minWidth: true,
  minHeight: true,
  maxWidth: true,
  maxHeight: true,
  flex: true,
  flexWrap: true,
  flexDirection: true,
  flexGrow: true,
  flexShrink: true,
  flexBasis: true,
  alignItems: true,
  alignContent: true,
  alignSelf: true,
  justifyItems: true,
  justifyContent: true,
  justifySelf: true,
  order: true,
  columnCount: true,
  border: true,
  borderTop: true,
  borderBottom: true,
  borderLeft: true,
  borderRight: true,
  pin: v => pinStyles[v],
  // Handle colors from both Spectrum and the CDS palette
  color: v => ({
    color: color(v)
  }),
  background: v => ({
    backgroundColor: color(v)
  }),
  borderColor: v => ({
    borderColor: color(v)
  }),
  gap: v => ({
    gap: space(v)
  }),
  columnGap: v => ({
    columnGap: space(v)
  }),
  rowGap: v => ({
    rowGap: space(v)
  }),
  spacing: v => ({
    padding: space(v)
  }),
  spacingTop: v => ({
    paddingTop: space(v)
  }),
  spacingBottom: v => ({
    paddingBottom: space(v)
  }),
  spacingStart: v => ({
    paddingLeft: space(v)
  }),
  spacingEnd: v => ({
    paddingRight: space(v)
  }),
  spacingVertical: v => ({
    paddingTop: space(v),
    paddingBottom: space(v)
  }),
  spacingHorizontal: v => ({
    paddingLeft: space(v),
    paddingRight: space(v)
  }),
  offset: v => ({
    margin: space(-v)
  }),
  offsetTop: v => ({
    marginTop: space(-v)
  }),
  offsetBottom: v => ({
    marginBottom: space(-v)
  }),
  offsetStart: v => ({
    marginLeft: space(-v)
  }),
  offsetEnd: v => ({
    marginRight: space(-v)
  }),
  offsetVertical: v => ({
    marginTop: space(-v),
    marginBottom: space(-v)
  }),
  offsetHorizontal: v => ({
    marginLeft: space(-v),
    marginRight: space(-v)
  }),
  css: v => v
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO Fix this
const mergeStyles = (a, b) => {
  const result = Object.assign({}, a, b);
  for (const key in a) {
    if (!a[key] || typeof b[key] !== 'object') continue;
    Object.assign(result, {
      [key]: Object.assign(a[key], b[key])
    });
  }
  return result;
};
const parseResponsiveStyle = (raw, styleFunction) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO Fix this
  const styles = {};
  let i = 0;
  while (i < mediaQueries.length) {
    const value = 'length' in raw ? raw[i] : raw[breakpointKeys[i]];
    const media = mediaQueries[i];
    const style = value != null ? styleFunction(value) : null;
    if (!media && style) Object.assign(styles, style);else if (media) styles[media] = style || {};
    i++;
  }
  return styles;
};
const createStyleParser = customStylePropFunctions => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO Fix this
  return componentProps => {
    let styles = {};
    for (const propName in componentProps) {
      const raw = componentProps[propName];
      if (raw == null) continue;
      let styleFunction = stylePropFunctions[propName];
      if (!styleFunction && customStylePropFunctions) styleFunction = customStylePropFunctions[propName];
      if (!styleFunction) continue;
      if (styleFunction === true)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO Fix this
        styleFunction = v => ({
          [propName]: v
        });
      if (typeof raw === 'object' && propName !== 'css') {
        styles = mergeStyles(styles, parseResponsiveStyle(raw, styleFunction));
        continue;
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO Fix this
      Object.assign(styles, styleFunction(raw));
    }
    return styles;
  };
};
const styleFunction = createStyleParser();
const ClassNameBox = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/jsx(Box, _objectSpread(_objectSpread({}, props), {}, {
  ref: ref,
  className: props?.className
})));
const Div = styled(ClassNameBox).withConfig({
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO Fix this
  shouldForwardProp: prop => !stylePropFunctions[prop]
})(props => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO Fix this
  const styles = styleFunction(props);
  if (!styles.display) styles.display = 'flex';
  return styles;
});
export { Div, color, createStyleParser, mergeStyles, parseResponsiveStyle, pinStyles, space, styleFunction, stylePropFunctions };
//# sourceMappingURL=Div.js.map
